import {
  BarChart3,
  Briefcase,
  Building2,
  CalendarClock,
  Coins,
  Columns3,
  LayoutDashboard,
  ReceiptIndianRupee,
  ScrollText,
  Settings,
  ShieldCheck,
  Users,
} from 'lucide-react'

// Shared sidebar nav for all TalentForge screens. Grouped so the owner can
// glance and know exactly where to go — no tutorial needed.
export const atsNav = [
  {
    items: [{ label: 'Dashboard', href: '/dashboard', icon: <LayoutDashboard className="h-5 w-5" /> }],
  },
  {
    title: 'HIRING',
    items: [
      { label: 'Pipeline', href: '/pipeline', icon: <Columns3 className="h-5 w-5" /> },
      { label: 'Candidates', href: '/candidates', icon: <Users className="h-5 w-5" /> },
      { label: 'Jobs', href: '/jobs', icon: <Briefcase className="h-5 w-5" /> },
      { label: 'Clients', href: '/clients', icon: <Building2 className="h-5 w-5" /> },
      { label: 'Interviews', href: '/interviews', icon: <CalendarClock className="h-5 w-5" /> },
    ],
  },
  {
    title: 'BILLING',
    items: [
      { label: 'Placements', href: '/placements', icon: <ReceiptIndianRupee className="h-5 w-5" /> },
      { label: 'Commissions', href: '/commissions', icon: <Coins className="h-5 w-5" /> },
    ],
  },
  {
    title: 'INSIGHTS',
    items: [{ label: 'Analytics', href: '/analytics', icon: <BarChart3 className="h-5 w-5" /> }],
  },
  {
    title: 'ADMIN',
    items: [
      { label: 'Settings', href: '/settings', icon: <Settings className="h-5 w-5" /> },
      { label: 'Compliance', href: '/compliance', icon: <ShieldCheck className="h-5 w-5" /> },
      { label: 'Audit log', href: '/audit', icon: <ScrollText className="h-5 w-5" /> },
    ],
  },
]
